import { createContext } from 'react';

const UserDetailsContext = createContext({
    /**
     * Although it is possible to remove the following I like to keep them here
     * because they help anyone importing UserDetailsContext to understand what properties/functions
     * this particular context has available
     */

    userId: '',
    userName: '',
    email: '',
    userLocations: [],
    token: '',

    /**
     * {Object} userDetails i.e. {[userId], [userName], [email], [userLocations], [token]}
     * @param {object} userDetails the user details to update
     */
    setUserDetails: userDetails => { }
});

export default UserDetailsContext;


// WEBPACK FOOTER //
// ./src/context/userDetails.context.js